import { Button } from '@/components/Button'
import {
  Section,
  SectionItem,
} from '@/features/jobs/info-gathering/components/Section'
import { PhysicalAddressSectionItems } from '@/features/jobs/info-gathering/components/PhysicalAddressSectionItems'
import { type PhysicalAddress } from '@/features/jobs/info-gathering/PhysicalAddress'
import {
  EmptyState,
  EmptyStateActions,
  EmptyStateDescription,
  EmptyStateTitle,
} from '@/components/EmptyState'

export interface BusinessInfoProps {
  hasProfile: boolean
  isLoading: boolean
  isEditable: boolean
  onEdit?: () => void
  businessName?: string
  dateOfIncorporation?: string
  employerIdentificationNumber?: string
  maskedEmployerIdentificationNumber?: string
  address?: PhysicalAddress
  emptyStateActionTestId?: string
  editButtonTestId?: string
}

export function BusinessInfo({
  hasProfile,
  isLoading,
  isEditable,
  onEdit,
  businessName,
  dateOfIncorporation,
  employerIdentificationNumber,
  maskedEmployerIdentificationNumber,
  address,
  emptyStateActionTestId,
  editButtonTestId,
}: BusinessInfoProps) {
  return (
    <>
      {!hasProfile && (
        <EmptyState size="section">
          <EmptyStateTitle>No business info yet</EmptyStateTitle>
          <EmptyStateDescription>
            Fill in the client's details on their behalf.
          </EmptyStateDescription>
          {isEditable && (
            <EmptyStateActions>
              <Button
                label="Fill in business info"
                variant="text"
                onPress={onEdit}
                testId={emptyStateActionTestId}
              />
            </EmptyStateActions>
          )}
        </EmptyState>
      )}
      {hasProfile && (
        <>
          <Section
            title="Business Information"
            isLoading={isLoading}
            actions={
              isEditable ? (
                <Button
                  label="Edit"
                  variant="text"
                  onPress={onEdit}
                  testId={editButtonTestId}
                />
              ) : undefined
            }
          >
            <SectionItem label="Business name" value={businessName} />

            <SectionItem
              label="Date of incorporation"
              value={dateOfIncorporation}
            />

            <SectionItem
              label="Employer identification number (EIN)"
              value={employerIdentificationNumber}
              maskedValue={maskedEmployerIdentificationNumber}
              isSensitive
            />
          </Section>

          <Section title="Contact Information" isLoading={isLoading} bordered>
            <PhysicalAddressSectionItems address={address} />
          </Section>
        </>
      )}
    </>
  )
}
